import { Tabs } from "antd-v5";
import React, { useMemo } from "react";
import { CellRenderers } from "utils/tableUtils";

import { GenericIntegrationView, TabConfig } from "../GenericIntegration";
import CrowdStrikeEdrConfigForm from "./CrowdStrikeEdrConfigForm";
import CrowdStrikeEdrFileUpload from "./CrowdStrikeEdrFileUpload";
import {
  CROWDSTRIKE_EDR_INTEGRATION_TYPE,
  CrowdStrikeEdrConfig,
} from "./crowdstrikeEdrConstants";

interface CrowdStrikeEdrViewProps {
  onUpdateConfigComponent?: () => void;
  name?: string;
  [key: string]: unknown;
}

const crowdStrikeEdrCustomColumns = [
  {
    title: "Falcon Cloud Region",
    dataIndex: ["configProperties", "falconBaseUrl"],
    render: (v: string) => CellRenderers.VALUE_OR_NA(v),
  },
];

export default function CrowdStrikeEdrView({
  onUpdateConfigComponent,
  name,
  ...rest
}: CrowdStrikeEdrViewProps) {
  const configTabs: TabConfig[] = useMemo(
    () => [
      {
        key: "crowdstrike_edr_web",
        label: "CrowdStrike EDR",
        integrationType: CROWDSTRIKE_EDR_INTEGRATION_TYPE,
        customColumns: crowdStrikeEdrCustomColumns,
      },
    ],
    [],
  );

  return (
    <Tabs
      defaultActiveKey="onboarding"
      items={[
        {
          key: "onboarding",
          label: "Foundry Config",
          children: (
            <GenericIntegrationView<CrowdStrikeEdrConfig>
              tabs={configTabs}
              FormComponent={CrowdStrikeEdrConfigForm}
              onUpdateConfigComponent={onUpdateConfigComponent}
              addButtonText="Add Configuration"
              name={name}
              {...rest}
            />
          ),
        },
        {
          key: "file_upload",
          label: "File Upload",
          children: <CrowdStrikeEdrFileUpload />,
        },
      ]}
    />
  );
}
